import React, { useState } from "react";
import { Dialog, InputAdornment, TextField, MenuItem, Popover } from "@material-ui/core";
import { ImageUtil } from "../../../../../utils";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./NetworkListing.type";
import { CategoryCard1, FloatingButton, Loading, Notification, Pulse, CustomButton } from "../../../../components";
import { BranchOutputModel, CountryOutputModel } from "../../../../../models";
import { BranchForm, CountryForm } from "../../..";
import { PriorityHigh as PriorityHighIcon, Search, Delete } from "@material-ui/icons";
import { EditIcon, DeleteIcon, BranchIcon, CountryIcon } from "../../../../icons";

const NetworkListingPresenter: React.FC<P_Props> = (props) => {
  const [visibleFloatingBtn, setVisibleFloatingBtn] = useState<boolean>(false);
  const [visibleWarningModal, setVisibleWarningModal] = useState<boolean>(false);
  const [countryDelete, setCountryDelete] = useState<CountryOutputModel | undefined>();
  const [branchDelete, setBranchDelete] = useState<BranchOutputModel | undefined>();
  const [visibleDeleteCountryModal, setVisibleDeleteCountryModal] = useState<boolean>(false);
  const [visibleDeleteBranchModal, setVisibleDeleteBranchModal] = useState<boolean>(false);

  const [countryPopup, setCountryPopup] = React.useState<{
    anchorEl: HTMLButtonElement | null;
    country: CountryOutputModel | null;
  }>({ anchorEl: null, country: null });

  const openCountryPopup = (
    event: React.MouseEvent<HTMLButtonElement>,
    country: CountryOutputModel
  ) => {
    setCountryPopup({ anchorEl: event.currentTarget, country });
  };

  const closeCountryPopup = () => {
    setCountryPopup({ anchorEl: null, country: null });
  };

  const toggleWarningModal = () => {
    setVisibleWarningModal(!visibleWarningModal);
  };

  const toggleDeleteCountryModal = (country?: CountryOutputModel | null) => {
    if (country) {
      setCountryDelete(country)
    }
    setVisibleDeleteCountryModal(!visibleDeleteCountryModal);
  };

  const toggleDeleteBranchModal = (branch) => {
    if (branch) {
      setBranchDelete(branch);
    }
    setVisibleDeleteBranchModal(!visibleDeleteBranchModal);
  };

  const toggleFloatingBtn = () => {
    setVisibleFloatingBtn(!visibleFloatingBtn);
  };

  const activeCountry = props.countries.find(
    (country) => country.id === props.filter.countryId
  );
  return (
    <>
      <div className="network-listing">
        <div className="network-listing__category">
          <div className="network-listing__category__header">
            <div className="title">Country</div>
          </div>
          <div className="network-listing__category__list">
            {props.countries.map((country) => {
              const isActive = country.id === activeCountry?.id;

              return (
                <CategoryCard1
                  key={country.id}
                  name={country.name}
                  onClick={() => {
                    props.onChangeCountry(country.id);
                  }}
                  selected={isActive}
                  onActionClick={(e) => {
                    openCountryPopup(e, country);
                  }}
                  picture={country.image || undefined}
                  buildPictureSrc={ImageUtil.buildCountryImgSrc}
                  isAvatar={true}
                />
              );
            })}
          </div>
        </div>
        <div 
          className="network-listing__content" 
          style={{ 
            opacity: visibleFloatingBtn ? "0.25" : "1", 
            pointerEvents: visibleFloatingBtn ? "none" : "auto"
          }}
        >
          <div className="network-listing__content__header">
            <div className="network-listing__content__header__title">
              {activeCountry?.name || "Branches"}
            </div>
            <div className="network-listing__content__header__actions">
              <TextField
                placeholder="Search by name"
                variant="outlined"
                className="search-input"
                inputProps={{ className: "input" }}
                InputProps={{
                  // style: { fontSize: "1.4rem" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className="icon" />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  props.onSearch(e.target.value);
                }}
              />
            </div>
          </div>
          {!Boolean(props.fetchedBranch.data.length) && props.fetchedBranch.loading && props.filter.countryId !== "" && <Loading />}
          {Boolean(props.fetchedBranch.data.length) && (
            <div className="network-listing__content__list">
              <div className="network-listing__content__list__header">
                <div className="text network-listing__content__list__title">Branch</div>
                <div className="text network-listing__content__list__address">Address</div>
                <div className="text network-listing__content__list__contact">Contact</div>
                <div className="text network-listing__content__list__control"></div>
              </div>
              <InfiniteScroll
                useWindow={false}
                pageStart={1}
                initialLoad={false}
                hasMore={
                  !props.fetchedBranch.loading &&
                  props.fetchedBranch.totalPages > props.fetchedBranch.page
                }
                loadMore={() => {
                  props.onLoadMore();
                }}
              >
                {props.fetchedBranch.data.map((branch) => {
                  return (
                    <div key={branch.id} className="network-listing__content__list__item">
                      <div
                        className="network-text network-listing__content__list__title"
                        onClick={() => {
                          props.openBranchFormModal(branch.id);
                        }}
                      >
                        {branch.title}<br />
                        {branch.subTitle}
                      </div>
                      <div className="network-text network-listing__content__list__address">{branch.address}</div>
                      <div className="network-text network-listing__content__list__contact">
                        {branch.contact.map((item, index) => (
                          <div key={index}>{item}</div>
                        ))}
                      </div>
                      <div className="network-text network-listing__content__list__control">
                        <CustomButton
                          onClick={(e) => {
                            e.stopPropagation();
                            props.openBranchFormModal(branch.id);
                          }}
                          color={"transparent"}
                          item={
                            <span>
                              <EditIcon
                                size={[20, 20]}
                                viewBox={[20, 20]}
                                color={"#272B2F"}
                              />
                            </span>
                          }
                        />
                        <CustomButton
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleDeleteBranchModal(branch);
                          }}
                          color={"transparent"}
                          item={
                            <span>
                              <DeleteIcon
                                size={[20, 20]}
                                viewBox={[20, 20]}
                                color={"#272B2F"}
                              />
                            </span>
                          }
                        />
                      </div>
                    </div>
                  );
                })}
                {Boolean(props.fetchedBranch.data.length) &&
                  props.fetchedBranch.loading && <Loading />}
              </InfiniteScroll>
            </div>
          )}
        </div>
      </div>
      <FloatingButton
        visible={visibleFloatingBtn}
        onClickPrimary={() => toggleFloatingBtn()}
        btns={[
          {
            color: "orange",
            title: "Branch",
            icon: <BranchIcon size={[22, 21]} color="white" />,
            onClick: (e) => {
              props.filter.countryId ? props.openBranchFormModal() : toggleWarningModal();
            },
          },
          {
            color: "purple",
            title: "Country",
            icon: <CountryIcon size={[20, 20]} color="white" />,
            onClick: (e) => {
              props.openCountryFormModal();
            },
          },
        ]}
      />

      <Dialog maxWidth="md" fullWidth open={props.visibleBranchForm}>
        <BranchForm
          branchId={props.visibleBranchId}
          countryId={props.filter.countryId}
          onCancel={() => {
            props.closeBranchFormModal();
            closeCountryPopup();
          }}
          onComplete_Create={() => {
            props.closeBranchFormModal();
            props.reloadListingCountry();
            closeCountryPopup();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeBranchFormModal();
            props.reloadListingCountry();
            closeCountryPopup();
          }}
          onComplete_Delete={() => {
            props.closeBranchFormModal();
            props.reloadListingCountry();
            closeCountryPopup();
          }}
        />
      </Dialog>

      <Dialog maxWidth="md" fullWidth open={props.visibleCountryForm}>
        <CountryForm
          onCancel={() => {
            props.closeCountryFormModal();
            closeCountryPopup();
          }}
          //initial={visibleCategoryForm.initData || undefined}
          onComplete_Create={() => {
            props.closeCountryFormModal();
            props.reloadListingCountry();
            closeCountryPopup();
            toggleFloatingBtn();
          }}
          onComplete_Update={() => {
            props.closeCountryFormModal();
            props.reloadListingCountry();
            closeCountryPopup();
          }}
          onComplete_Delete={() => {
            props.closeCountryFormModal();
            props.reloadListingCountry();
            closeCountryPopup();
          }}
        />
      </Dialog>

      <Popover
        open={Boolean(countryPopup.anchorEl)}
        anchorEl={countryPopup.anchorEl}
        onClose={closeCountryPopup}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          onClick={() => {
            toggleDeleteCountryModal(countryPopup.country);
            closeCountryPopup();
          }}
          style={{ color: "red", fontSize: "1.4rem" }}
        >
          <Delete style={{ fontSize: "2.2rem", marginRight: "0.8rem" }} />
          Delete
        </MenuItem>
      </Popover>

      <Notification
        visible={visibleDeleteCountryModal}
        title="Delete Warning"
        subTitle="This action will clear all existing branches of this country. Are you sure still delete?"
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="network-listing__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteCountryModal();
              }}
            >
              Cancel
            </button>
            <button
              className="network-listing__delete-modal__actions__confirm"
              onClick={() => {
                if (countryDelete?.id) {
                  props.onDeleteCountry(countryDelete.id);
                }
                toggleDeleteCountryModal();
              }}
            >
              Delete
            </button>
          </>
        }
      />

      <Notification
        visible={visibleDeleteBranchModal}
        title="Delete Branch"
        subTitle={`Are you sure you want to delete branch “${branchDelete?.title}“? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="network-listing__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteBranchModal(branchDelete);
              }}
            >
              Cancel
            </button>
            <button
              className="network-listing__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteBranchModal(branchDelete);
                if (branchDelete?.id)
                  props.onDeleteBranch(branchDelete.id);
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      <Notification
        className="network-listing__warning-modal"
        visible={visibleWarningModal}
        title="Create branch warning"
        subTitle="You must create country first or assign branch for an available country!"
        icon={
          <Pulse color="yellow">
            <div className="notification-icon-box yellow">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <button
            className="network-listing__warning-modal__actions__confirm"
            onClick={() => {
              toggleWarningModal();
            }}
          >
            Confirm
          </button>
        }
      />
    </>
  );
};

export default NetworkListingPresenter;
